import { AuthApiService, NavigationService, OidcService } from '@revenuewell/front-end-bundle';
import { CropAndSaveRequest } from './types/crop-save-request';
import { ImageLibraryData } from './types/image-library-data';

export class ImageLibraryService extends AuthApiService {
  private config: any;

  public constructor(config: any, oidcService: OidcService) {
    super(oidcService, new NavigationService());
    this.config = config;
  }

  getImageList = async (locationId: number, imageCategoryId: number): Promise<ImageLibraryData> => {
    const url = `${this.config.practice.url}/Image/GetImageList` +
      `?&id=${imageCategoryId}&locId=${locationId}`;
    const response = await fetch(url, { method: 'POST', credentials: 'include', });
    return await response.json();
  }

  uploadImage = async (locationId: number, imageCategoryId: number, file: File): Promise<{ Success: boolean }> => {
    const url = `${this.config.practice.url}/Image/UploadImage?locId=${locationId}&idImageCategory=${imageCategoryId}`;

    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      body: formData
    });

    return await response.json();
  }

  deleteImage = async (locationId: number, fileName: string): Promise<{ IsSuccess: boolean }> => {
    const url = `${this.config.practice.url}/Image/DeleteImage?locId=${locationId}`;
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ fileName })
    });
    return await response.json();
  }

  cropAndSaveImage = async (locationId: number, request: CropAndSaveRequest): Promise<{ Data: { IsSuccess: boolean, Message: string } }> => {
    const url = `${this.config.practice.url}/Image/CropAndSaveImage` +
      `?locId=${locationId}&fileNameWithExt=${request.fileName}&imageCategoryType=${request.imageCategoryType}` +
      `&x1=${request.x1}&x2=${request.x2}&y1=${request.y1}&y2=${request.y2}`;
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' }
    });
    return await response.json();
  }
}
